module.exports = __webpack_public_path__ + "static/img/partner-dst.ab5c7f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/partner/partner-dst.png
// module id = WkdX
// module chunks = 34